import styled from "styled-components";

const MessageParts = (props) => {
  const { part } = props;
  return (
    <div className="part inline">
      {part.textType === 'speech' && (
        <PartSpeech className="part_speech_placeholder">{part.text}&nbsp;&nbsp;</PartSpeech>
      )}
      {part.textType === 'comment' && (
        <PartComment isNarrator className="part_comment_placeholder italic">
          {part.text}&nbsp;&nbsp;
        </PartComment>
      )}
    </div>
  );
};

export default MessageParts;

const PartSpeech = styled.div`
  color: ${props =>
    props.isNarrator == true ? 'rgba(169, 169, 169, 1)' : 'rgba(255, 255, 255, 1)'};
  display: inline;
`;

const PartComment = styled.div`
  display: inline;
  color: ${props =>
    props.isNarrator == true ? 'rgba(169, 169, 169, 1)' : 'rgba(255, 255, 255, 1)'};
  font-size: 16px;
  margin-top: 5px;
  margin-bottom: 5px;
`;